import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FontIcon } from 'react-toolbox';
import cx from 'classnames';
import { themr } from 'react-css-themr';
import Card from '../Card';
import S from './styles.scss';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';
import { sortBy } from 'lodash';
import ReactTooltip from 'react-tooltip';

class CollapsableCard extends Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: true };
  }

  toggleExpand = () => this.setState({ isExpanded: !this.state.isExpanded });

  renderActions = () => {
    /**
     * Sorting to guarantee the order of actions doesn't
     * change based on which are avialable
     */
    const actions = sortBy(this.props.actions, ['text']);
    return actions.map((action) => {
      const { text, icon, toolTipMessage, onClick, className = '' } = action;
      if (!['Approve', 'edit', 'done', 'Copy Labor Lines', 'Merge to Original'].includes(text)) {
        return (<div
          key={icon}
          className={cx(S.disabledButton, S[icon], className)}
        >
          <FontIcon
            key={icon}
            value={icon}
            className={S.cardIcon}
          />
          {toolTipMessage ? <span data-tip data-for="anchor-element" className={`${S.actionText} ${S.disabledText}`}>{text}</span> :
          <span className={`${S.actionText} ${S.disabledText}`}>{text}</span> }
          <ReactTooltip id="anchor-element">
            <span>{toolTipMessage}</span>
          </ReactTooltip>
        </div>);
      }
      return (<button
        id={`${this.props.actionBtnPrefix}${text}`}
        key={icon}
        className={cx(S.cardButton, S[icon], this.props.theme.cardAction, className)}
        onClick={onClick}
      >
        <FontIcon
          key={icon}
          value={icon}
          className={S.cardIcon}
        />
        <span className={S.actionText}>{text}</span>
      </button>);
    });
  };

  render = () => {
    const { title, titleNote, startsExpanded, headerStyles, theme } = this.props;
    const icon = this.state.isExpanded && startsExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
    const headerClass = cx(S.cardContentPadding, theme.cardHeader, headerStyles);
    return (<Card className={theme.cardContainer}>
      <div className={headerClass}>
        <span className={theme.cardTitle}>{title}</span>
        <span className={S.cardTitleNote}>{titleNote}</span>
        <div className={S.receiveReleaseEdit}>
          <MediaQuery minWidth={CUT_POINT}>
            {(matches) => {
              if (matches) return this.renderActions();
              return (<div className={S.actionWrapper}>{this.renderActions()}</div>);
            }}
          </MediaQuery>
        </div>
        <FontIcon value={icon} className={theme.cardPointer} onClick={this.toggleExpand} />
      </div>
      {this.state.isExpanded && <div className={theme.cardContentContainer}>
        {this.props.children}
      </div>}
    </Card>);
  }
}

CollapsableCard.defaultProps = {
  title: 'Title',
  titleNote: '',
  actions: [],
  startsExpanded: true,
};

CollapsableCard.propTypes = {
  startsExpanded: PropTypes.bool,
  title: PropTypes.node,
  titleNote: PropTypes.string,
  children: PropTypes.node,
  headerStyles: PropTypes.string,
  actionBtnPrefix: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    onClick: PropTypes.func,
  })),
  theme: PropTypes.shape({
    cardContainer: PropTypes.string,
    cardTitle: PropTypes.string,
    cardHeader: PropTypes.string,
    cardAction: PropTypes.string,
    cardPointer: PropTypes.string,
    cardContentContainer: PropTypes.string,
  }),
};

export default themr('CollapsableCard', S)(CollapsableCard);



// WEBPACK FOOTER //
// ./client/app/shared/components/CollapsableCard/index.jsx